export enum ListDataSchemasSortFieldsEnum {
  name = 'name',
  createdAt = 'createdAt',
  isArchived = 'isArchived',
}
